import { Box } from '@mui/material';

import { RadioBoxButton } from '@/components';
import {
  onboardingActions,
  selectOnboardingStepInputs,
  STEP_IDS,
  useAppDispatch,
  useAppSelector,
} from '@/store';

import { styles } from '../styles';
import { Footer } from './Footer';
import { Header } from './Header';
import { ModalTitle } from './ModalTitle';

export const IsDesignatedForm = () => {
  const dispatch = useAppDispatch();
  const stepInputs = useAppSelector(selectOnboardingStepInputs);
  const { value: isDesignated } = stepInputs[STEP_IDS.isDesignated];

  const updateInput = (input: boolean) =>
    dispatch(
      onboardingActions.updateStepInputs({
        step: STEP_IDS.isDesignated,
        input,
      }),
    );

  return (
    <Box sx={styles.formContainer}>
      <Header Title={<Title />} />
      <Box
        sx={[
          styles.formPrimarySection,
          { display: 'flex', flexDirection: 'column' },
        ]}>
        <Box sx={styles.checkboxContainer}>
          <RadioBoxButton
            label={"Yes, I'm designated"}
            checked={!!isDesignated}
            onChange={() => updateInput(true)}
          />
        </Box>
        <Box sx={styles.checkboxContainer}>
          <RadioBoxButton
            label={"No, I'm not designated"}
            checked={isDesignated === false}
            onChange={() => updateInput(false)}
          />
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

const Title = () => (
  <ModalTitle>Do you have an accounting or finance designation?</ModalTitle>
);
